/** A coupled numeric range; either bound may be open (null). */
export interface NumberRange { min: number | null; max: number | null; }

/** A validation rule for a range: an i18n key when the range breaks it, null when it is fine. */
export type RangeRule = (r: NumberRange) => string | null;

// g15-i18n-keys
const RANGE_RULE_KEYS = {
  minAboveMax: 'validation.rangeInvalid',
  nonNegative: 'validation.nonNegative',
} as const;

/** The rule every range carries: the minimum may not exceed the maximum. */
export const minNotAboveMax: RangeRule = r =>
  r.min != null && r.max != null && r.min > r.max ? RANGE_RULE_KEYS.minAboveMax : null;

/** Neither bound may be negative (a quantity, a total). */
export const nonNegative: RangeRule = r =>
  (r.min != null && r.min < 0) || (r.max != null && r.max < 0) ? RANGE_RULE_KEYS.nonNegative : null;
